<template>
    <div>
        <el-row>
            <el-col>
                <image-slider
                    :image-urls="base64Image ? [base64Image] : []"
                    :editor="true"
                    :error="showRequiredError"
                    @delete="deleteImage()"></image-slider>
            </el-col>
        </el-row>

        <el-row class="mt-4">
            <el-col class="d-flex flex-row align-items-center">
                <div>
                    <input ref="file" type="file" @change="onFileChange" class="d-none"/>

                    <el-button type="success" round :loading="isLoading" @click="uploadImage()">
                        Subir Imagen <i class="el-icon-upload"></i>
                    </el-button>
                </div>

                <div v-if="this.showRequiredError" class="ml-3 error">
                    Campo obligatorio
                </div>
            </el-col>
        </el-row>

        <el-row class="mt-4">
            <el-col>
                <i class="el-icon-info icon-gray"></i> Selecciona una fotografía horizontal.
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {dialogs} from '../../constants/text-constants';
    import ImageSlider from '../../components/ImageSlider';

    export default {
        name: "ImageUploadBase64",
        components: {
            ImageSlider
        },
        props: {
            value: String,
            doLoading: Boolean,
            showRequiredError: Boolean
        },
        data() {
            return {
                url: null,
                base64Image: null,
                loading: false
            }
        },
        created() {
            this.base64Image = this.value;
        },
        computed: {
            isLoading() {
                return this.doLoading || this.loading;
            }
        },
        methods: {
            uploadImage() {
                if (this.base64Image === undefined) {
                    this.openImageSelector()
                } else {
                    this.confirmReplaceImage()
                }
            },
            confirmReplaceImage() {
                this.$confirm(dialogs.image.upload.replace.text, {
                    confirmButtonText: dialogs.image.upload.replace.confirm,
                    cancelButtonText: dialogs.image.upload.replace.cancel,
                    dangerouslyUseHTMLString: true
                })
                    .then(() => this.openImageSelector())
                    .catch(() => {
                    });
            },
            openImageSelector() {
                this.$refs.file.click()
            },
            onFileChange(e) {
                let file = e.target.files[0];
                if (file) {
                    this.loading = true;
                    let img = new Image();
                    img.src = URL.createObjectURL(file);
                    img.onload = () => {
                        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                            this.uploadError('La imagen debe estar en formato JPG o PNG!');
                        } else if (img.naturalWidth < 800 || img.naturalHeight < 600) {
                            this.uploadError('La imagen debe tener una resolución mínima de 800x600!');
                        } else if (file.size / 1024 / 1024 > 5) {
                            this.uploadError('La imagen excede los 5MB!');
                        } else {
                            let reader = new FileReader();
                            reader.onloadend = () => {
                                this.base64Image = reader.result;
                                this.emitInput();
                                this.$refs.file.value = null;
                            };
                            reader.readAsDataURL(file);
                        }
                        this.loading = false;
                    };
                } else {
                    this.base64Image = null;
                    this.emitInput();
                }
            },
            uploadError(message) {
                this.$message.error(message);
                this.base64Image = null;
                this.emitInput();
            },
            deleteImage() {
                this.base64Image = null;
                this.emitInput();
            },
            emitInput() {
                this.$emit('input', this.base64Image)
            }
        },
        watch: {
            value: function () {
                this.base64Image = this.value;
            }
        }
    }
</script>

<style scoped>
    .error {
        font-style: italic;
        font-weight: 500;
        font-size: 10px;
        line-height: 12px;
        color: #D89172;
    }
</style>
